<div class="p-4">
  <h6 class="screen-header text-start mt-4 fw-bold" mat-dialog-title>{{isUpdateGroup?'Update':'Add New'}} Group</h6>
  <form class="text-center overflow-auto" [formGroup]="editGroupForm" (ngSubmit)="onFormSubmit()"
    [style.height.px]="getFormHeight()">
    <mat-dialog-content>
      <mat-card-content>
        <div class="p-1">
          <mat-label class="float-start required">Name</mat-label>
          <mat-form-field appearance="outline" class="w-100">
            <input matInput formControlName="name" placeholder="Enter Group name" #nameInput [attr.maxLength]="limits.name">
            @if (editGroupForm.get('name')?.hasError('required')) {
              <mat-error>
                Group name is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="p-1">
          <mat-label class="float-start">Description</mat-label>
          <mat-form-field appearance="outline" class="w-100">
            <textarea matInput formControlName="description" placeholder="Enter Group Description" [attr.maxLength]="limits.description"></textarea>
          </mat-form-field>
        </div>


        <div class="w-100 ps-0 pe-4 pb-4 position-absolute bottom-0">
          <div class="row ps-0 pe-4 m-0">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 p-1 m-0">
              <button class="secondary-btn w-100" mat-flat-button type="button"
              (click)="cancelClick()">Cancel</button>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 p-1 m-0">
              <button class="primary-btn w-100" mat-flat-button type="submit">{{isUpdateGroup?'Update':'Add Group'}}</button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-dialog-content>
  </form>
</div>